<template>
    <div class="app-container">
        <div class="anjian-wrap">
            <div class="common-section-bg anjian-shaixuan">
                <div class="shaixuan-item">
                    <el-input v-model="listQuery.name" clearable style="width: 200px;" placeholder="请输入名称查找" />
                </div>
                <div class="shaixuan-item">
                    <!-- @keyup.enter.native="handleFilter" -->
                    <el-button type="primary" @click="handleFilter()" icon="el-icon-search">
                        {{ $t("table.search") }}
                    </el-button>
                </div>
                <div class="shaixuan-item">
                    <el-button type="primary" icon="el-icon-plus" @click="handleCreate">
                        {{ $t("table.add") }}
                    </el-button>
                </div>
            </div>
            <div class="common-section-bg common-section-top biaoge-data">
                <el-table v-loading="listLoading" :data="tableData" style="width: 100%">
                    <el-table-column prop="id" label="id" />
                    <el-table-column prop="name" label="问卷名称" />
                    <!--                    <el-table-column label="封面图" width="200" >-->
                    <!--                        <template slot-scope="scope">-->
                    <!--                            <el-image-->
                    <!--                                    style="width: 100px; height: 100px"-->
                    <!--                                    :src="$adddom(scope.row.thumb)"-->
                    <!--                                    :preview-src-list="[$adddom(scope.row.thumb)]">-->
                    <!--                            </el-image>-->
                    <!--                        </template>-->
                    <!--                    </el-table-column>-->
                    <el-table-column label="操作" align="center" width="300" fixed="right">
                        <template slot-scope="scope">
                            <el-button @click="showEdit(scope.row.id)"
                                style="background: #FD962B; border-color: #FD962B" type="primary">
                                编辑
                            </el-button>
                            <el-button @click="resetPwd(scope.row.id)" type="success">
                                题目配置
                            </el-button>
                            <el-button type="danger" @click="delFun(scope.row.id)">
                                删除
                            </el-button>
                        </template>
                    </el-table-column>

                </el-table>
                <!-- 分页 -->
                <pagination v-show="total" :total="total" :page.sync="listQuery.page" :limit.sync="listQuery.size"
                    @pagination="getList" />
            </div>
        </div>
        <el-drawer custom-class="custom-drawer" :visible.sync="showDrawer" :close-on-press-escape="false"
            :wrapper-closable="false" :show-close="false" size="1000px">
            <template slot="title">
                <div class="custom-title">
                    <div class="title-name">{{ isEdit ? '编辑' : '新增' }}</div>
                    <i class="el-icon-circle-close close-btn pointer" @click="closeDrawerFun" />
                </div>
            </template>
            <div class="custom-content">
                <el-form ref="ruleForm" :model="danwei" :rules="rules" label-width="130px">
                    <el-form-item label="问卷名称" prop="name">
                        <el-input v-model="danwei.name" />
                    </el-form-item>
                    <!--                    <el-form-item label="封面图">-->
                    <!--                        <image-upload ref="imageUpload"-->
                    <!--                                      v-if="showUpload"-->
                    <!--                                      :tipInfo="`上传图片格式为'jpg','jpeg','png','gif'，大小不超过2M，建议尺寸690*250,请自己处理好宽高比例`"-->
                    <!--                                      :image-list="imageDefaultList"-->
                    <!--                                      :maxNumber="1"-->
                    <!--                                      @updateImg="onUpdateImg($event)"></image-upload>-->
                    <!--                    </el-form-item>-->
                </el-form>
                <div class="fix-fotter">
                    <div class="default-btn pointer" @click="tijiao('ruleForm')">提交
                    </div>
                </div>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import wenjuan from '@/api/tianzheng/wenjuan'
import Pagination from '@/components/Pagination' // Secondary package based on el-pagination
import ImageUpload from '@/components/Upload/image'

export default {
    components: {
        Pagination,
        ImageUpload
    },
    data() {
        return {
            roleList: [],
            StatusList: [{ id: 1, name: "正常" }, { id: 0, name: "禁用" }],
            isEdit: 0, // 0新增 1编辑
            showDrawer: false,
            listLoading: false,
            total: 0,
            ModelList: [],
            danwei: {
                name: '',
                account: '',
                role_id: ''
            },
            rules: {
                name: [{
                    required: true,
                    message: '请输入问卷名称',
                    trigger: 'blur'
                }],
            },

            listQuery: {
                name: '',
                page: 1,
                size: 10
            },
            tableData: [],
            showUpload: false,
            imageDefaultList: [],
            thumbList: []
        }
    },
    created() {
        this.getList()
    },
    methods: {
        // 题目配置
        resetPwd(id) {
            this.$router.push({
                path: "/wenjuan/Topic",
                query: {
                    id: id
                }
            })
        },
        onUpdateImg(val) {
            let thumbList = [];
            val.forEach((ele, idx) => {
                thumbList.push(ele.path);
            });
            this.thumbList = thumbList;
        },
        /**
         * @name: 获取列表
         * @return {*}
         * @desc:
         */
        getList(val) {
            if (val && val.page) {
                this.listQuery.page = val.page
            }
            this.listLoading = true
            wenjuan.list(this.listQuery).then(res => {
                this.listLoading = false
                if (res.code == 200) {
                    this.tableData = res.result.list
                    this.total = res.result.total
                }
            })
        },
        /**
         * @name: 点击子项 0新增 1编辑
         * @param {*} type
         * @param {*} id
         * @return {*}
         * @desc:
         */
        handleCreate() {
            const that = this
            this.isEdit = 0
            this.showDrawer = true
            this.resetForm()
        },
        showEdit(index) {
            const that = this
            this.isEdit = 1
            this.showDrawer = true
            this.showUpload = true
            this.resetForm()

            that.id = index
            wenjuan.detail({
                id: that.id
            }).then(res => {
                if (res.code == 200) {
                    this.danwei = res.result
                    if (that.danwei.thumb) {
                        let imgList = [];
                        let obj = {
                            name: that.danwei.thumb,
                            path: that.danwei.thumb,
                            url: that.$publicData.imgUrl + that.danwei.thumb,
                        }
                        imgList.push(obj);
                        // 回显图
                        that.imageDefaultList = JSON.stringify(imgList);
                    };
                }
            })
        },
        /**
         * @name: 提交
         * @param {*} formName
         * @return {*}
         * @desc:
         */
        tijiao(formName) {
            this.$refs[formName].validate(valid => {
                if (valid) {
                    if (this.thumbList.length > 0) {
                        this.danwei.thumb = this.thumbList[0];
                    }
                    if (this.id) {
                        // 编辑
                        const params = this.danwei
                        wenjuan.edit(params).then(res => {
                            if (res.code == 200) {
                                this.$message.success(res.message)
                                this.closeDrawerFun()
                                this.getList(this.listQuery.page)
                            }
                        })
                    } else {
                        // 新增
                        wenjuan.create(this.danwei).then(res => {
                            if (res.code === 200) {
                                this.$message.success(res.message)
                                this.closeDrawerFun()
                                this.getList()
                            }
                        })
                    }
                } else {
                    this.$message.warning(this.$t('form.verifyMsg'))
                }
            })
        },
        /**
         * @name: 关闭弹层
         * @return {*}
         * @desc:
         */
        closeDrawerFun() {
            this.showDrawer = false
            this.resetForm()
        },
        /**
         * @name: 删除
         * @param {*} row
         * @return {*}
         * @desc:
         */
        delFun(row) {
            this.$confirm('此操作将永久删除该数据, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                wenjuan.remove({
                    id: row
                }).then(res => {
                    if (res.code == 200) {
                        this.$message.success(res.message)
                        this.getList(this.listQuery.page)
                    } else {
                        this.$message.error(res.message)
                    }
                })
            }).catch(() => {
            })
        },
        /**
         * @name: 清空
         * @return {*}
         * @desc:
         */
        resetForm() {
            this.id = null
            this.danwei.name = ''
            this.thumbList = [];
            this.imageDefaultList = "";
            if (this.$refs.imageUpload) {
                this.$refs.imageUpload.clearFileList();
            }
            this.showUpload = true;
              if (this.$refs.ruleForm) {
                this.$refs.ruleForm.resetFields()
              }
        },
        handleFilter() {
            this.listQuery.page = 1;
            this.getList();
        },

    }
}
</script>
